/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Faq_A3Inputs */

const en_diff_faq_a3 = /** @type {(inputs: Diff_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By index. Element zero is compared with element zero, and so on. Elements beyond the length of the shorter array are reported as added or removed at their index. Moved elements are not detected as moves.`)
};

const ko_diff_faq_a3 = /** @type {(inputs: Diff_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인덱스 기준입니다. 0번 요소를 0번 요소와 비교하는 식입니다. 더 짧은 배열의 길이를 넘는 요소는 해당 인덱스에서 추가 또는 제거로 보고됩니다. 이동한 요소는 이동으로 감지되지 않습니다.`)
};

const ja_diff_faq_a3 = /** @type {(inputs: Diff_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添字基準です。0 番要素を 0 番要素と比べる、という具合です。短い方の配列の長さを超える要素は、その添字で追加または削除として報告されます。移動した要素は移動として検出されません。`)
};

/**
* | output |
* | --- |
* | "By index. Element zero is compared with element zero, and so on. Elements beyond the length of the shorter array are reported as added or removed at their in..." |
*
* @param {Diff_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_faq_a3 = /** @type {((inputs?: Diff_Faq_A3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Faq_A3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_faq_a3(inputs)
	if (locale === "ko") return ko_diff_faq_a3(inputs)
	return ja_diff_faq_a3(inputs)
});